import { OkDataSchema } from "./common.js";

export const RestartDataSchema = OkDataSchema;
